/**
 * Classificazione **di presentazione** del Sinottico (FR-009), 1:1 con `SinotticoStatoEnum` del
 * backend.
 *
 * ⚠️ Enum **numerico**, non di stringhe: nessun `JsonStringEnumConverter` è registrato in
 * `ArchiConnectLocalApi`, quindi `System.Text.Json` serializza ogni enum come intero. È la stessa
 * classe di trappola di `orgId`/`organizzazioneId`: una forma che non corrisponde non produce un
 * errore, produce un valore sbagliato in silenzio.
 *
 * ⚠️ **Deviazione dichiarata** dalla convenzione di `_models/generated/`: questo enum è scritto a
 * mano invece che generato da TypeGen, perché il tipo backend vive in `Service/Models` e non in
 * `Contracts.Enums` (FR-009). I valori ordinali devono restare allineati.
 */
export enum SinotticoStato {
  Ferma = 0,
  InLavorazione = 1,
  InPausa = 2,
  Sospeso = 3,
  Terminato = 4,
  Allarme = 5,
}

/** Etichette in italiano, usate da tessere, tabella e pill di stato. */
export const SINOTTICO_STATO_LABEL: Record<SinotticoStato, string> = {
  [SinotticoStato.Ferma]: 'Ferma',
  [SinotticoStato.InLavorazione]: 'In lavorazione',
  [SinotticoStato.InPausa]: 'In pausa',
  [SinotticoStato.Sospeso]: 'Sospeso',
  [SinotticoStato.Terminato]: 'Terminato',
  [SinotticoStato.Allarme]: 'Allarme',
};

/** Ordine di presentazione delle pill: dal più critico al più quieto. */
export const SINOTTICO_STATI_ORDINATI: SinotticoStato[] = [
  SinotticoStato.Allarme,
  SinotticoStato.InLavorazione,
  SinotticoStato.InPausa,
  SinotticoStato.Sospeso,
  SinotticoStato.Terminato,
  SinotticoStato.Ferma,
];

/** Gli stati che «solo anomalie» seleziona. */
export const SINOTTICO_STATI_ANOMALI: SinotticoStato[] = [
  SinotticoStato.Allarme,
  SinotticoStato.InPausa,
  SinotticoStato.Sospeso,
];
